<template>
  <div class="detail-wrapper" v-if="detailData">
    <div class="detail-main">
        <div class="swiper" v-if="imgs.length && !detailData.info.video">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img
                        :src="
                        detailData.info.image.indexOf('?') > -1
                            ? detailData.info.image + '&imageView2/2/w/640'
                            : detailData.info.image + '?imageView2/2/w/640'
                        "
                        alt=""
                    />
                </div>
                <div class="swiper-slide" v-for="item in imgs" :key="item">
                    <img :src="item" alt="" />
                </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
        </div>
      <div class="detail-img" v-else>
        <img
          v-if="!detailData.info.video"
          :src="
            detailData.info.image.indexOf('?') > -1
              ? detailData.info.image + '&imageView2/2/w/640'
              : detailData.info.image + '?imageView2/2/w/640'
          "
          alt=""
        />
        <video
          v-else
          :src="detailData.info.video"
          controls
		  controlslist="nodownload"
          loop
          :poster="slimImageFilter(detailData.info.image, 750, 420)"
        ></video>
      </div>
      <div class="detail-title-wrap">
        <div class="detail-vote-wrap">
          <div class="detail-vote-inner">
            <span class="vote-num" @click="goblockchain">{{ detailData.votes }}</span
            >&nbsp;票
          </div>
        </div>
        <p class="detail-title">
          {{ detailData.info.title
          }}<i v-if="detailData.info.subtitle">{{
            detailData.info.subtitle
          }}</i>
        </p>
      </div>
      <div class="detail-desc" v-html="detailData.info.intro"></div>
    </div>
    <div class="detail-page">
      <span class="back-btn" @click="backPage">返回上一页</span>
      <span class="vote-btn" @click="handleVote(detailData.id)">投票</span>
    </div>
    <dialog-component
      @loginEvent="getUserInfon"
      @wxauthorizeEvent="wxAuthorizeCallback"
      :baseData="baseData"
    ></dialog-component>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min'
import 'swiper/swiper-bundle.css'
import COVER from "@/utils/COVER";
import DialogComponent from "@/components/Dialog";
import COVERAPP from "@/utils/COVERAPP";
import FILTER from "@/utils/filters";

import moment from "moment";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      aid: "",
      vid: "",
      detailData: null,
      openid: "",
      imgs: [],
      blockchainClickCount: 0
    };
  },
  props: ["activityData", "baseData"],
  computed: {
    ...mapState(["dialogData", "userInfo"])
  },
  watch: {
        userInfo (val) {
            if (val.token && this.activityData.shareCount) {
                this.coverShare();
            }
        }
    },
  components: {
    DialogComponent
  },
  created() {
    this.aid = this.$route.query.id || "";
    this.vid = this.$route.query.vid || "";
    this.getDetail();
  },
  mounted() {
    if (COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
      this.getUserInfon();
    }
    setTimeout(() => {
      this.setPageLoadingAsync(false);
    }, 500);
  },
  methods: {
    ...mapMutations(["setUserInfo", "setOpenDownLoadFlag"]),
    ...mapActions([
      "setPageLoadingAsync",
      "setDialogDataAsync",
      "setUserInfoAsync",
    ]),
    getUserInfon() {
      this.setUserInfoAsync();
    },
    slimImageFilter(img, imgW, imgH) {
      return FILTER.slimImageFilter(img, imgW, imgH);
    },
    //分享
    share() {
      let data = this.baseData.share;
      let shareData = {
        title: data.title,
        desc: data.desc,
        imgUrl: data.imgUrl,
        link: data.link || window.location.href,
      };
      COVER.share(shareData);
    },
    getShareData() {
      const _this = this;
      let shareData = this.baseData.share;
      return {
        title: "快来为TA打call，就差你了", // 分享标题
        desc: _this.detailData.info.title, // 分享描述
        link: window.location.href,
        imgUrl: shareData.imgUrl,
        type: "link",
        origin: "None",
        callback: function (res) {
          // 分享成功
          COVER.$post("/vote/share", {
            aid: _this.aid,
            uid: _this.userInfo.token,
            userinfo: _this.userInfo,
          }).then((ret) => {
            if (ret.errno == 0) {
              _this.setDialogDataAsync({
                message: "分享成功!",
                btns: [
                  {
                    text: "确认",
                  },
                ],
              });
              return;
            }
          });
        },
      };
    },
    // APP分享
    coverShare() {
        const data = COVER.getShareCount(this.baseData.share, this.aid, this.userInfo);
        COVER.share(data);
    },
    // APP主动调起分享
    doShare() {
        if (!COVERAPP.Attribute.isApp()) {
            return;
        }
        const data = COVER.getShareCount(this.baseData.share, this.aid, this.userInfo);
		COVERAPP.Method.Share(data);
    },
    getDetail() {
      const _this = this;
      COVER.$get(`/vote/${this.vid}`, {}).then((res) => {
        const info = res.data.info || {};
        let imgs = [];
        for (let x in info) {
          for (let i = 0; i < 10; i++) {
            if (x.indexOf('image' + i) > -1 && info[x]) {
              imgs.push(info[x]);
            }
          }
        }

        if (info['atlas']) {
            var atlas = info['atlas'].split(',')
            imgs.push(...atlas)
        }

        _this.detailData = res.data;
        _this.imgs = imgs;
        if (_this.activityData.shareCount) {
          _this.coverShare();
        } else {
          _this.share();
        }
        this.$nextTick(() => {
            console.log(imgs.length)
            this.slide()
        })
      });
    },
    handleVote(id) {
        if (this.activityData.isAppHandle && !COVERAPP.Attribute.isApp()) {
            this.setOpenDownLoadFlag(true);
            return;
        }
      this.voteOptions = {
        aid: this.aid,
        uid: this.userInfo.token,
        vid: id,
        userinfo: this.userInfo,
        openid: this.openid,
      };
      this.$nextTick(() => {
        this.vote(id);
      });
    },
    vote(id) {
      const _this = this;
      if (!COVERAPP.Attribute.isApp() && this.activityData.external) {
        if (
          localStorage.getItem(
            this.aid + "_skip_app_" + moment().format("YYYYMMDD")
          )
        ) {
          this.setDialogDataAsync({
            message:
              "投票次数已用完！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
            btns: [
              {
                text: "确认",
                className: "downLoad-app",
              },
            ],
          });
          return;
        }
        this.setDialogDataAsync({
          message:
            "恭喜你，投票成功！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
          btns: [
            {
              text: "确认",
              className: "downLoad-app",
            },
          ],
        });
        this.detailData.votes++;
        localStorage.setItem(
          this.aid + "_skip_app_" + moment().format("YYYYMMDD"),
          true
        );
        return;
      }
      if (!this.userInfo.token) {
        this.setDialogDataAsync({
          message: "参与活动，需登录!",
          btns: [
            {
              text: "去登录",
              className: "login-btn",
            },
            {
              text: "取消",
              className: "close-btn",
            },
          ],
        });
        return;
      }
      this.setDialogDataAsync({
        message: "投票中，请稍候...",
      });
      COVER.$post("/vote", this.voteOptions).then((res) => {
        if (res.errno == 0) {
          const shareNoticeKey =
            this.voteOptions.aid +
            "_share_notice_" +
            moment().format("YYYYMMDD");
          if (
            this.activityData.shareCount &&
            !localStorage.getItem(shareNoticeKey)
          ) {
            // 今天第一次投票
            this.setDialogDataAsync({
              message:
                "感谢你为我投票！分享后还能额外获得" +
                this.activityData.shareCount +
                "次投票机会，记得分享哦！",
              btns: [
                {
                  text: "确认",
                  className: "share-btn",
                  callback: _this.doShare,
                },
              ],
            });
            // 记录今天已投票
            localStorage.setItem(shareNoticeKey, true);
          } else {
            // 今天不是第一次投票
            this.setDialogDataAsync({
              message: "投票成功",
              btns: [
                {
                  text: "确认",
                },
              ],
            });
          }
          this.detailData.votes++;
        } else if (COVERAPP.Attribute.isApp() && res.errno == 1250) {
          this.setDialogDataAsync({
            message: "参与活动，需绑定微信!",
            btns: [
              {
                text: "绑定微信",
                className: "wxAuthorize-btn",
              },
              {
                text: "取消",
                className: "close-btn",
              },
            ],
          });
        } else if (res.errno == 2022) {
          this.setOpenDownLoadFlag(true);
        } else {
          this.setDialogDataAsync({
            message: res.errmsg || "投票失败，请重试",
            btns: [
              {
                text: "确认",
              },
            ],
          });
        }
      }).catch(() => {
        this.setDialogDataAsync(null);
      });
    },
    wxAuthorizeCallback(openid) {
      let _this = this;
      let verifyOpenid = `${_this.userInfo.user_id.toString(
        36
      )}_${openid}_${(+moment().format("YYYYMMDD")).toString(36)}`;
      _this.userInfo.openid = openid;
      _this.openid = verifyOpenid;
      store.commit("setUserInfo", _this.userInfo);
    },
    backPage() {
      this.$router.push(`/list?id=${this.aid}`);
    },
    slide () {
        new Swiper('.detail-wrapper .swiper', {
            loop: true,
            autoHeight: true,
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
            }
        }) 
    },
    goblockchain () {
        if (this.activityData.blockchain) {
            this.blockchainClickCount++;
            if (this.blockchainClickCount == 10) {
                window.location.href = `https://activity.thepage.cn/pollchain/#/?aid=${this.aid}&vid=${this.vid}`;
            }
        }
    }
  },
};
</script>

<style lang="less">
.detail-img {
  width: 100%;
  overflow: hidden;
  background-color: #eaeaea;
  position: relative;
  video {
    width: 100%;
    background-color: #000;
    height: 5.6rem;
  }
}
.video-btn {
  width: 100%;
  height: 100%;
  background: url(https://yunyingcdn.thecover.cn/o_1c1uiks011tbds1u1djqbjj1vh6d.png)
    no-repeat center / 2rem auto;
  position: absolute;
  left: 0;
  top: 0;
}
.detail-title-wrap {
  background-color: #f4f3f9;
  overflow: hidden;
  min-height: 1.296296rem;
  position: relative;
}
.detail-vote-wrap {
  width: 3.703704rem;
  background-color: #db332a;
  font-size: 0.388889rem;
  color: #fff;
  float: left;
  margin: 0;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
.detail-vote-inner {
  font-weight: 600;
  line-height: 1.3;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.detail .vote-num {
  font-size: 0.555556rem;
}
.detail-title {
  font-size: 0.481481rem;
  line-height: 1.4;
  color: #383838;
  font-weight: bold;
  padding: 0.37037rem 0.462963rem 0.37037rem 4.148148rem;
  box-sizing: border-box;
  margin: 0;
  i {
    font-size: 0.3rem;
    color: #333;
    font-style: normal;
    font-weight: normal;
    display: block;
  }
}
.detail-title span {
  display: block;
  font-size: 0.3rem;
  padding-top: 0.1rem;
  line-height: 1.2;
  color: #666;
}
.detail-desc {
  font-size: 0.388889rem;
  color: #383838;
  padding: 0.601852rem 0.462963rem 0.601852rem 0.555556rem;
  line-height: 1.5;
}
.detail-page {
  letter-spacing: -4px;
  text-align: center;
  padding-bottom: 2rem;
}
.detail-page span {
  display: inline-block;
  width: 3.148148rem;
  margin: 0 0.462963rem;
}
.back-btn {
  font-size: 0.444444rem;
  color: #db332a;
  box-sizing: border-box;
  border: 2px solid #db332a;
  height: 1.018519rem;
  border-radius: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.03rem;
  padding: 0.22rem 0;
  text-align: center;
}
.vote-btn {
  font-size: 0.444444rem;
  color: #fff;
  font-weight: bold;
  width: 3.148148rem;
  height: 1.092593rem;
  border: 2px solid #f5df78;
  padding: 0.2rem 0;
  line-height: 1.3;
  text-align: center;
  background: #dc372f;
  border-radius: 0.8rem;
  margin: 0 auto;
  box-shadow: 0 0.185185rem 0.462963rem #fac3c3;
  letter-spacing: 0.1rem;
  box-sizing: border-box;
}
.vote-btn.voted {
  color: #db332a;
  border: 2px solid #db332a;
  background: #fff;
}
</style>
